import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { List } from "../../models/List";
import { ListService } from "../../services/ListService";
import { Response } from "@/shared/models/Response";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import AddOptions from "./AddOptions/AddOptions.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED
} from "@/shared/constants/FormConstants";
import { LIST_ACCESS, LIST_CONSTANTS } from "../../constants/ListConstants";
import { Http } from "@status/codes";
import { OptionSchema } from "../../models/OptionSchema";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import {
  GENERAL_CONSTANTS,
  MANAGED_LISTS_TYPES
} from "@/shared/constants/GeneralConstants";
import { Utils } from "@/shared/utils/utils";
import { Icon } from "@/shared/models/Icon";
import { AxiosError } from "axios";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { EditList } from "../../models/EditList.model";

Vue.use(Vuetify);
@Component({
  name: "SaveList",
  components: {
    AddOptions,
    ModalTemplate,
    DynamicSelect
  }
})
export default class SaveList extends Vue {
  @Prop() isModal!: boolean;
  @Prop() listIdProp?: string;
  @Inject() listService!: ListService;
  @Inject() managedListsService!: ManagedListsService;

  dialog = false;
  dialogOptions = false;
  modalTitle = "";
  modalText = "";
  isEditingOption = false;
  indexEditing = -1;
  isEditingList = false;
  idEditing = "";
  listEditing!: List;
  validList = false;
  listTypeModel = [{ id: "", name: "" }];

  iconsList: Icon[] = [];
  colorState = false;
  menu = false;
  menuHelp = false;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  btnRoundClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  cardClass = STYLE_CLASSES.CARD;
  btnClassDeploy = STYLE_CLASSES.BTN_COLOR_PICKER_DEPLOY;
  dflexClass = STYLE_CLASSES.COL_DFLEX_CENTER;
  alignCenterClass = STYLE_CLASSES.ALIGN_CENTER;

  COLOR_CTE = LIST_CONSTANTS.COLOR;
  ICON_SHAPE = LIST_CONSTANTS.ICON_SHAPE;
  HELP_ICON_SHAPE = LIST_CONSTANTS.HELP_ICON_SHAPE;
  TOOLTIP_INFO = LIST_CONSTANTS.LIST_COLOR_TOOLTIP;
  HELP_TOOLTIP_INFO = LIST_CONSTANTS.INFO_TOOLTIP;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  PAGE_TITLE = LIST_CONSTANTS.PAGE_TITLE_ADD;
  LIST_NAME = LIST_CONSTANTS.LABEL.LIST_NAME;
  LIST_ACTIVE = FORM_CONSTANTS.LABEL.STATE;
  LIST_IS_CATEGORY = FORM_CONSTANTS.LABEL.IS_CATEGORY;
  IS_CATEGORY_DOCUMENTS = FORM_CONSTANTS.LABEL.IS_CATEGORY_DOCUMENTS;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_MESSAGES.CANCEL_MODAL.TITLE;
  ADD_OPTIONS = LIST_CONSTANTS.BUTTON.ADD_OPTIONS;
  OPTIONS_TITLE = LIST_CONSTANTS.OPTIONS_TITLE;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  OPTION_NAME = LIST_CONSTANTS.OPTIONS_INFO.NAME;
  OPTION_VALUE = LIST_CONSTANTS.OPTIONS_INFO.VALUE;
  OPTION_SCORE = LIST_CONSTANTS.OPTIONS_INFO.SCORE;
  OPTION_STATE = LIST_CONSTANTS.OPTIONS_INFO.STATE;
  SWITCH_OFF = LIST_CONSTANTS.SWITCH_OFF;
  HEADER_INFO = LIST_CONSTANTS.TEXT_INFO.INFO;
  DETAILS_INFO = LIST_CONSTANTS.TEXT_INFO.DETAILS;
  CATEGORY_INFO = LIST_CONSTANTS.TEXT_INFO.CATEGORY;
  CATEGORY_INFO_DETAIL = LIST_CONSTANTS.TEXT_INFO.CATEGORY_INFO;
  COLOR_INFO = LIST_CONSTANTS.TEXT_INFO.COLOR;
  COLOR_INFO_DETAIL = LIST_CONSTANTS.TEXT_INFO.COLOR_INFO;
  ADD_LIST = LIST_CONSTANTS.LABEL.ADD_LIST;
  SEARCH_LIST = LIST_CONSTANTS.LABEL.SEARCH_LIST;
  LIST_ADITIONAL_CONFIG = LIST_CONSTANTS.LABEL.LIST_ADITIONAL_CONFIG;
  HINT_LIST = LIST_CONSTANTS.HINT.LIST;
  HINT_SEARCH_LIST = LIST_CONSTANTS.HINT.SEARCH_LIST;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  showMoreInfo = false;
  fieldNotBlankSpace = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];
  listCounter = 0;
  errorsName: string[] = [];
  selectConfigListType: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    messageLabel: this.ADD_LIST,
    hint: this.HINT_SEARCH_LIST,
    persistenthint: true,
    required: true
  };

  listModel: EditList = {
    name: "",
    options: [],
    state: false,
    isCategory: false,
    isDocumentCategory: false,
    color: "#000000FF",
    listType: ""
  };

  editComparationStr = "";
  invalidEdit = false;

  async mounted() {
    await this.loadTypeListByID();
    await this.getIcons();

    this.changeList();
  }

  get listType() {
    return this.listTypeModel[0].id;
  }

  set listType(id: string) {
    const option = this.selectConfigListType.listAll.find(
      item => item.id == id
    );
    this.listTypeModel = [{ id: option?.id ?? "", name: option?.name ?? "" }];
  }

  @Watch("listIdProp")
  changeList() {
    this.listCounter++;
    this.dialogOptions = false;
    try {
      if (this.listIdProp) {
        this.idEditing = this.listIdProp;
        this.getListById(this.idEditing);
        this.PAGE_TITLE = LIST_CONSTANTS.PAGE_EDIT_TITLE;
        this.isEditingList = true;
      } else {
        this.openDialogOptions();
        this.isEditingList = false;
      }

      if (!this.isModal) {
        this.goToStart("saveListForm");
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("listModel", { deep: true })
  validateEdit() {
    if (this.isEditingList) {
      this.invalidEdit =
        JSON.stringify(this.listModel) === this.editComparationStr;
    }
  }

  @Watch("listType")
  changeType() {
    this.listModel.listType = this.listTypeModel[0].id ?? "";
  }

  openDialogOptions() {
    this.dialogOptions = true;
    this.isEditingOption = false;
    this.indexEditing = -1;
  }

  async getIcons() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );

      this.iconsList = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  onClose() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE);
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  addOptions(id: string): void {
    this.listCounter++;
    this.openDialogOptions();

    Utils.moveElement(id, LIST_CONSTANTS.REFERENCES_TEXTS.OPTIONS_CONTAINER);
    Utils.scrollToElement(id, this);
  }

  async save(): Promise<void> {
    if (this.listModel.options.length === 0) {
      Snackbar.popWarning(LIST_CONSTANTS.DIALOG_MESSAGE.MIN_OPTIONS);
      return;
    }
    if (this.isEditingList) {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.dialog = true;
    } else {
      try {
        const exist: boolean = await this.listExist(this.listModel.name.trim());

        if (exist) {
          Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.LIST_NAME_EXIST);
          return;
        } else {
          this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
          this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
          this.dialog = true;
        }
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  async listExist(nameList: string): Promise<boolean> {
    const responseData: Response<void> = await this.listService.checkIfExistByName(
      nameList
    );

    if (responseData.code === Http.NotFound) {
      return false;
    } else if (responseData.code === Http.Found) {
      return true;
    } else {
      throw Error();
    }
  }

  deleteOption(index: number) {
    this.listCounter++;
    this.dialogOptions = false;
    this.listModel.options.splice(index, 1);
  }

  updateOption(index: number, id: string) {
    this.isEditingOption = true;
    this.indexEditing = index;
    this.dialogOptions = true;

    Utils.moveElement(id, LIST_CONSTANTS.REFERENCES_TEXTS.ADD_OPTION + index);
    Utils.scrollToElement(id, this);
  }

  handleModalOptionCancel() {
    this.dialogOptions = false;
    this.isEditingOption = false;
    this.indexEditing = -1;
  }

  async doIfOk() {
    let responseData: Response<string | void>;

    if (this.isEditingList) {
      try {
        this.listEditing.dateChanged = Date.now();
        this.listEditing.changedBy = "";
        this.listEditing.options = this.listModel.options;
        this.listEditing.state = this.listModel.state;
        this.listEditing.isCategory = this.listModel.isCategory;
        this.listEditing.isDocumentCategory = this.listModel.isDocumentCategory;
        this.listEditing.color = this.listModel.color;
        this.listEditing.listType = this.listModel.listType;
        const optionsSchema = this.getOptionsSchema();
        this.listEditing.optionsSchema = optionsSchema;
        responseData = await this.listService.updateList(
          this.idEditing,
          this.listEditing
        );
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden) {
          responseData = {
            code: Http.Forbidden,
            message: FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.PUT
          };
          Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.PUT);
        } else {
          Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
          responseData = { code: Http.InternalServerError, message: "" };
        }
      }
    } else {
      try {
        const optionsSchema = this.getOptionsSchema();
        const list: List = new List(
          this.listModel.name.trim(),
          this.listModel.state,
          this.listModel.options,
          optionsSchema,
          this.listModel.isCategory,
          this.listModel.isDocumentCategory,
          this.listModel.color,
          this.listModel.listType
        );

        responseData = await this.listService.saveList(list);
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden) {
          responseData = {
            code: Http.Forbidden,
            message: FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.POST
          };
          Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.POST);
        } else {
          Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
          responseData = { code: Http.InternalServerError, message: "" };
        }
      }
    }

    if (responseData.code === Http.Ok) {
      Snackbar.popSuccess(LIST_CONSTANTS.DIALOG_MESSAGE.SAVE_LIST_OK);
      this.onClose();
    } else if (responseData.code === Http.Forbidden) {
      Snackbar.popError(responseData.message);
    } else {
      Snackbar.popError(LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_LIST);
    }
  }

  async handleModalAccept() {
    this.dialog = false;
    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.doIfOk();
    }
  }

  handleModalCancel() {
    this.dialog = false;
  }

  async getListById(id: string) {
    try {
      const responseData: Response<List> = await this.listService.getListById(
        id
      );

      if (responseData.code === Http.NotFound) {
        Snackbar.popError(
          LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_EDIT_ID_NOT_FOUND
        );
      } else if (
        responseData.code === Http.Found &&
        responseData.data !== undefined
      ) {
        this.listEditing = responseData.data;
        this.listModel.name = responseData.data.name;
        this.listModel.options = responseData.data.options;
        this.listModel.state = responseData.data.state;
        this.listModel.isCategory = responseData.data.isCategory;
        this.listModel.isDocumentCategory =
          responseData.data.isDocumentCategory;
        this.listModel.color = responseData.data.color ?? "";
        this.listType = responseData.data.listType;

        this.editComparationStr = JSON.stringify({
          ...this.listModel,
          listType: responseData.data.listType
        });
        this.$emit(
          LIST_CONSTANTS.REFERENCES_TEXTS.EDIT_TITLE,
          this.listModel.name
        );
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadTypeListByID() {
    try {
      const responseData: Response<List> = await this.listService.getListById(
        MANAGED_LISTS_TYPES.IDOF_TYPELIST
      );

      if (responseData.code === Http.NotFound) {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.DEFAULT_LIST_NOT_FOUND);
      } else if (
        responseData.code === Http.Found &&
        responseData.data !== undefined
      ) {
        this.selectConfigListType.listAll = responseData.data.options.map(
          item => {
            return { id: item.value, name: item.title };
          }
        );
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  getOptionsSchema(): Array<OptionSchema> {
    const optionSchema: OptionSchema[] = [];
    this.listModel.options.forEach(option => {
      if (option.enabled) {
        optionSchema.push({
          const: option.value,
          title: option.title,
          icon: option.uiSetup.iconUrl
        });
      }
    });
    return optionSchema;
  }

  btnColorActivator() {
    if (this.listModel.color) {
      this.menu = false;
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.LIST,
      this.listModel.name
    );
  }
}
